import { message } from "antd";

export const showCustomMessage = (msg: string, resent?: boolean) => {
  const key = "custom-message";
  message.open({
    type: "success",
    key,
    duration: 0,
    content: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {resent ? (
          <span>{`Email ${msg} Successfully`}</span>
        ) : (
          <span>{`User ${msg} Successfully`}</span>
        )}
        <svg
          onClick={() => message.destroy(key)}
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <path
            fill="#2E3191"
            d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
          ></path>
        </svg>
      </div>
    ),
  });
};

export const CloseButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fill="#2E3191"
        fillRule="evenodd"
        d="M6.793 6.793a1 1 0 0 1 1.414 0L12 10.586l3.793-3.793a1 1 0 1 1 1.414 1.414L13.414 12l3.793 3.793a1 1 0 0 1-1.414 1.414L12 13.414l-3.793 3.793a1 1 0 0 1-1.414-1.414L10.586 12L6.793 8.207a1 1 0 0 1 0-1.414"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const options = [
  { value: "Senior_counsellor", label: "Senior Counselor" },
  { value: "Counselor", label: "Counselor" },
  { value: "Oca", label: "OCA" },
];
